import { FakeIntersectionObserver } from '../FakeIntersectionObserver';
export function getIntersectionObserverConstructor() {
    return typeof IntersectionObserver !== "undefined" ?
        IntersectionObserver :
        FakeIntersectionObserver;
}
//# sourceMappingURL=GetIntersectionObserverConstructor.js.map